/* AagamStuti festive calendar page. Plain JavaScript, no libraries. Loaded after aagamstuti-festivals.js,
   which fetches the festival files and shares its helpers (window.__asFestivals.kit). Draws [data-fc="page"]:
   the next-festival card, the month grid and every upcoming festival with its pooja guide and an "Add to my calendar" file. */
(function () {
  'use strict';

  var F = window.__asFestivals;
  if (!F || F.page) return;
  var K = F.kit;
  var MONTHS = K.MONTHS, DAY = K.DAY, DAYFULL = K.DAYFULL, reduce = K.reduce;
  var pad = K.pad, addDays = K.addDays, short = K.short, endOf = K.endOf, h = K.h;
  var build = K.build, status = K.status, whenText = K.whenText, icon = K.icon, pill = K.pill, dateTile = K.dateTile, setStatus = K.setStatus;

  /* ---------- calendar file (.ics) ---------- */
  function esc(t) { return String(t).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
  function fold(line) { var out = [], i = 0; while (line.length - i > 72) { out.push(line.slice(i, i + 72)); i += 72; } out.push(line.slice(i)); return out.join('\r\n '); }
  function ymd(s) { return s.replace(/-/g, ''); }
  function downloadIcs(e, host) {
    var now = new Date(), stamp = now.getUTCFullYear() + pad(now.getUTCMonth() + 1) + pad(now.getUTCDate()) + 'T' + pad(now.getUTCHours()) + pad(now.getUTCMinutes()) + pad(now.getUTCSeconds()) + 'Z';
    var desc = (e.g.summary || '') + (e.note ? ' ' + e.note : '') + ' Dates are for New Delhi. Please confirm with your pandit.';
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//AagamStuti//Festive calendar//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
      'UID:' + e.id + '@' + host, 'DTSTAMP:' + stamp, 'DTSTART;VALUE=DATE:' + ymd(e.date), 'DTEND;VALUE=DATE:' + ymd(addDays(endOf(e), 1)),
      'SUMMARY:' + esc(e.name), 'DESCRIPTION:' + esc(desc), 'TRANSP:TRANSPARENT', 'END:VEVENT', 'END:VCALENDAR'];
    var blob = new Blob([lines.map(fold).join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = h('a', { href: url, download: e.id + '.ics' });
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  /* ---------- calendar page ---------- */
  function renderPage(root, data) {
    var b = build(data);
    var showGuides = root.getAttribute('data-guides') !== 'false';
    var showGrid = root.getAttribute('data-grid') !== 'false';
    var host = location.hostname || 'aagamstuti';
    var main = root.querySelector('[data-fc-list]');
    var aside = root.querySelector('[data-fc-aside]');
    main.textContent = '';
    aside.textContent = '';
    setStatus(root, '');
    if (!b.list.length) {
      main.appendChild(h('p', { class: 'as-lede', text: 'There are no upcoming festivals in the list right now. Please check back soon.' }));
      return;
    }

    /* next-up card */
    var first = b.list[0], st0 = status(first, b.today);
    var big;
    if (st0.kind === 'later') big = [h('span', { class: 'as-fnext__n', text: String(st0.n) }), h('span', { class: 'as-fnext__u', text: st0.n === 1 ? 'day to go' : 'days to go' })];
    else big = [h('span', { class: 'as-fnext__n as-fnext__n--word', text: st0.label }), h('span', { class: 'as-fnext__u', text: '' })];
    var nextCard = h('div', { class: 'as-fnext' }, [
      h('div', { class: 'as-fnext__count', 'aria-hidden': 'true' }, big),
      h('div', { class: 'as-fnext__txt' }, [
        h('span', { class: 'as-eyebrow', text: st0.kind === 'today' || st0.kind === 'live' ? 'Happening now' : 'Next festival' }),
        h('h2', { class: 'as-fnext__name' }, [first.name]),
        first.g.hindi ? h('span', { class: 'as-sacred as-fnext__hi', lang: 'hi', text: first.g.hindi }) : null,
        h('p', { class: 'as-fnext__when', text: whenText(first) }),
        h('a', { class: 'as-ulink', href: '#' + first.id, 'data-fc-go': first.id, text: 'See the pooja guide' })
      ])
    ]);
    aside.appendChild(nextCard);

    /* month grid */
    var monthsWithEvents = {};
    b.list.forEach(function (e) {
      var d = e.date;
      for (var guard = 0; guard < 40 && d <= endOf(e); guard++) { monthsWithEvents[d.slice(0, 7)] = true; d = addDays(d, 1); }
    });
    var keys = Object.keys(monthsWithEvents).sort();
    var startKey = b.today.slice(0, 7) > keys[0] ? b.today.slice(0, 7) : keys[0];
    var lastKey = keys[keys.length - 1];
    var cur = first.date.slice(0, 7) >= startKey ? first.date.slice(0, 7) : startKey;
    var gridWrap = h('div', { class: 'as-fcal', hidden: !showGrid });
    aside.appendChild(gridWrap);
    var live = h('p', { class: 'as-vh', role: 'status', 'aria-live': 'polite' });
    gridWrap.appendChild(live);

    function monthKeyShift(k, n) { var y = +k.slice(0, 4), m = +k.slice(5, 7) - 1 + n; y += Math.floor(m / 12); m = ((m % 12) + 12) % 12; return y + '-' + pad(m + 1); }
    function drawGrid(focusNav) {
      var y = +cur.slice(0, 4), m = +cur.slice(5, 7) - 1;
      var head = h('div', { class: 'as-fcal__head' });
      var prev = h('button', { type: 'button', class: 'as-fcal__nav', 'aria-label': 'Previous month', disabled: cur <= startKey }, [icon(root, 'chev-l')]);
      var next = h('button', { type: 'button', class: 'as-fcal__nav', 'aria-label': 'Next month', disabled: cur >= lastKey }, [icon(root, 'chev-r')]);
      head.appendChild(prev);
      head.appendChild(h('h2', { class: 'as-fcal__title', text: MONTHS[m] + ' ' + y }));
      head.appendChild(next);
      var tbl = h('table', { class: 'as-fcal__tbl' });
      tbl.appendChild(h('caption', { class: 'as-vh', text: MONTHS[m] + ' ' + y + ': days with a festival are buttons' }));
      var thead = h('tr'); DAY.forEach(function (d, i) { thead.appendChild(h('th', { scope: 'col', abbr: DAYFULL[i], text: d.charAt(0) })); });
      tbl.appendChild(h('thead', null, [thead]));
      var tbody = h('tbody');
      var firstW = new Date(Date.UTC(y, m, 1)).getUTCDay(), dim = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
      var day = 1 - firstW;
      while (day <= dim) {
        var tr = h('tr');
        for (var c = 0; c < 7; c++, day++) {
          if (day < 1 || day > dim) { tr.appendChild(h('td', { class: 'as-fcal__off' })); continue; }
          var ds = y + '-' + pad(m + 1) + '-' + pad(day);
          var hits = b.list.filter(function (e) { return e.date <= ds && endOf(e) >= ds; });
          var td = h('td', { class: ds === b.today ? 'is-today' : null });
          if (hits.length) {
            var starting = hits.filter(function (e) { return e.date === ds; });
            td.appendChild(h('button', { type: 'button', class: 'as-fcal__day' + (starting.length ? ' has-start' : ' has-span'), 'data-fc-go': (starting[0] || hits[0]).id,
              'aria-label': short(ds) + ': ' + hits.map(function (e) { return e.name; }).join(', ') }, [h('span', { text: String(day) })]));
          } else { td.appendChild(h('span', { class: 'as-fcal__plain', text: String(day) })); }
          tr.appendChild(td);
        }
        tbody.appendChild(tr);
      }
      tbl.appendChild(tbody);
      gridWrap.textContent = '';
      gridWrap.appendChild(live);
      gridWrap.appendChild(head);
      gridWrap.appendChild(tbl);
      prev.addEventListener('click', function () { shift(-1); });
      next.addEventListener('click', function () { shift(1); });
      if (focusNav) { var want = focusNav < 0 ? prev : next; var other = focusNav < 0 ? next : prev; (want.disabled ? other : want).focus(); }
    }
    function shift(n) {
      cur = monthKeyShift(cur, n);
      drawGrid(n);
      live.textContent = MONTHS[+cur.slice(5, 7) - 1] + ' ' + cur.slice(0, 4);
    }
    drawGrid();

    /* the list, grouped by month */
    var lastMonth = '', group = null, countByMonth = {};
    b.list.forEach(function (e) { var k = e.date.slice(0, 7); countByMonth[k] = (countByMonth[k] || 0) + 1; });
    b.list.forEach(function (e, idx) {
      var k = e.date.slice(0, 7);
      if (k !== lastMonth) {
        lastMonth = k;
        var mm = +k.slice(5, 7) - 1;
        group = h('section', { class: 'as-fc__month', 'aria-labelledby': 'fc-m-' + k });
        group.appendChild(h('h2', { class: 'as-fc__mh', id: 'fc-m-' + k }, [MONTHS[mm] + ' ' + k.slice(0, 4), h('span', { class: 'as-fc__mc', text: countByMonth[k] + (countByMonth[k] === 1 ? ' festival' : ' festivals') })]));
        main.appendChild(group);
      }
      group.appendChild(renderItem(root, e, b.today, showGuides, host, idx === 0));
    });
  }

  function renderItem(root, e, today, showGuides, host, isFirst) {
    var g = e.g, st = status(e, today), shop = g.shop || {};
    var head = h('div', { class: 'as-fi__head' }, [
      dateTile(e),
      h('div', { class: 'as-fi__main' }, [
        h('div', { class: 'as-fi__row' }, [
          (icon(root, g.icon || 'diya') ? h('span', { class: 'as-fi__ic' }, [icon(root, g.icon || 'diya')]) : null),
          h('h3', { class: 'as-fi__name' }, [e.name]),
          g.hindi ? h('span', { class: 'as-fi__hi as-sacred', lang: 'hi', text: g.hindi }) : null
        ]),
        h('p', { class: 'as-fi__when', text: whenText(e) }),
        h('p', { class: 'as-fi__sum', text: g.summary || '' }),
        e.note ? h('p', { class: 'as-fi__note' }, [icon(root, 'info'), h('span', { text: e.note })]) : null
      ]),
      h('div', { class: 'as-fi__side' }, [pill(st)])
    ]);
    var el = h('article', { class: 'as-fi', id: e.id, 'data-fi': e.id }, [head]);

    if (showGuides && (g.steps && g.steps.length)) {
      var det = h('details', { class: 'as-fi__guide' });
      var sum = h('summary', null, [h('span', { text: 'Pooja guide' }), icon(root, 'chev-d')]);
      det.appendChild(sum);
      var inner = h('div', { class: 'as-fi__gbody' });
      var cols = h('div', { class: 'as-fi__cols' });
      if (g.needs && g.needs.length) {
        var ul = h('ul', { class: 'as-fi__needs' });
        g.needs.forEach(function (n) {
          ul.appendChild(h('li', null, [n.url ? h('a', { href: n.url, text: n.label }) : n.label]));
        });
        cols.appendChild(h('div', null, [h('h4', { class: 'as-fi__h', text: 'What you will need' }), ul]));
      }
      var ol = h('ol', { class: 'as-fi__steps' });
      g.steps.forEach(function (s) { ol.appendChild(h('li', { text: s })); });
      cols.appendChild(h('div', null, [h('h4', { class: 'as-fi__h', text: 'How it is observed' }), ol]));
      inner.appendChild(cols);
      if (g.tip) inner.appendChild(h('p', { class: 'as-fi__tip', text: g.tip }));
      inner.appendChild(h('p', { class: 'as-fine', text: 'A general guide. Rituals and timings differ by family and region, so please follow your own pandit.' }));
      var acts = h('div', { class: 'as-fi__acts' });
      if (shop.url) acts.appendChild(h('a', { class: 'as-cta as-cta--sm', href: shop.url }, [h('span', { text: shop.label || 'Shop the pooja' }),
        h('span', { class: 'as-cta__arch' }, [(function () { var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true'); var p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', 'M5 12h14M13 6l6 6-6 6'); s.appendChild(p); return s; })()])]));
      var cal = h('button', { type: 'button', class: 'as-fi__cal' }, [icon(root, 'calendar'), h('span', { text: 'Add to my calendar' })]);
      cal.addEventListener('click', function () { downloadIcs(e, host); });
      acts.appendChild(cal);
      inner.appendChild(acts);
      det.appendChild(inner);
      el.appendChild(det);
    } else {
      var acts2 = h('div', { class: 'as-fi__acts as-fi__acts--bare' });
      if (shop.url) acts2.appendChild(h('a', { class: 'as-ulink', href: shop.url, text: shop.label || 'Shop the pooja' }));
      el.appendChild(acts2);
    }
    return el;
  }

  function go(root, id) {
    var el = root.querySelector('[data-fi="' + id + '"]');
    if (!el) return;
    var det = el.querySelector('details');
    if (det) det.open = true;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    el.classList.add('is-target');
    setTimeout(function () { el.classList.remove('is-target'); }, 2400);
    var name = el.querySelector('.as-fi__name');
    if (name) { name.setAttribute('tabindex', '-1'); try { name.focus({ preventScroll: true }); } catch (err) { name.focus(); } }
  }
  function wirePage(root) {
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-fc-go]');
      if (!t || !root.contains(t)) return;
      ev.preventDefault();
      var id = t.getAttribute('data-fc-go');
      try { history.replaceState(null, '', '#' + id); } catch (err) {}
      go(root, id);
    });
  }
  function openHash(root) {
    var id = (location.hash || '').replace(/^#/, '');
    if (id && root.querySelector('[data-fi="' + id + '"]')) go(root, id);
  }

  F.page = {
    render: function (root, data) { renderPage(root, data); wirePage(root); openHash(root); }
  };
  window.addEventListener('hashchange', function () { Array.prototype.slice.call(document.querySelectorAll('[data-fc="page"]')).forEach(openHash); });
  F.scan();
})();